import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
    //baseURL: `http://localhost:7380/api/`,
    baseURL: `https://expocafe-rentabilidad.complementservices.com/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
